import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as Types from './operations';

const defaultOptions = {} as const;
export const TableDataFragmentDoc = gql`
  fragment TableData on TableData {
    staticData {
      ante
      brandMask
      chatLang
      cap
      clubId
      countryRestrictionInverted
      currency
      defaultBuyIn
      filter
      game
      hiBet
      icon
      isHiLo
      isOneOnOne
      isPlayMoney
      isTableStarter
      loBet
      maxBuyIn
      maxPlayers
      minChipsLimit
      name
      poolBlockMinHands
      tableStakes {
        stakes
        bringIns
        blinds
        antes
      }
      visibilityMaskEx
      variableAntes
      visibilityMask
      tableTypeId
      tableInstanceFlags
      tableId
      tableFlags2
      tableFlags
      structure
      specialName
      serverObject
      server
      seatFinderId
      scalePm
      restrictedCountries
    }
    dynamicData {
      numPlayers
    }
  }
`;
export const ZoomDataStructFragmentDoc = gql`
  fragment ZoomDataStruct on ZoomDataStruct {
    dynamicData {
      avgPlayers
      avgPotSize
      avgStackSize
      avgVpip
      earlyBirdMins
      earlyBirdMultipliers {
        licenseId
        multiplier
      }
      licenseEarlyBirdMultiplier
      handsPerHour
      numPlayers
      publProp
    }
    lastEntry
    staticData {
      ante
      blitzFlags
      brandMask
      cap
      chatLang
      countryRestrictionInverted
      currency
      defaultBuyIn
      game
      hiBet
      id
      isHiLo
      isMorphLobby
      isOneOnOne
      isPlayMoney
      loBet
      maxBuyIn
      maxPlayersPerTable
      minChipsLimit
      name
      replayerInstance
      quickLobbyVisible
      restrictedCountries
      scalePm
      server
      serverObj
      specialName
      structure
      tableFlags
      tableFlags2
      tableStakes {
        blinds
        antes
        bringIns
        stakes
      }
      visibilityMask
      visibilityMaskEx
    }
  }
`;
export const TournDataStructFragmentDoc = gql`
  fragment TournDataStruct on TournDataStruct {
    dynamicData {
      dummy1
      entrants
      fakeStatus
      goldenSnGEligibleStub
      goldenSnGMilestoneAwardStub
      goldenSnGTotalAddonStub
      happyHoursMultipliers
      mixTournSatellite
      prizePoolMoneyToPublish
      prizePoolMoneyToPublish64
      prizePoolToPublish
      prizePoolToPublish64
      prizePoolUnit
      publProp
      timedTournPlayersThreshold
    }
    entryIds
    lastEntry
    staticData {
      activeFlags
      admissionId
      admissionPrice
      admissions
      awardScheme
      brandAccessMask
      buyIn
      chatLang
      clubId
      countryRestrictionInverted
      currency
      customSpeedDisplayName
      dayTwoStart
      dayTwoStartSec
      doNotAllowToUnreg
      dummy1
      favReference
      fppBuyIn
      game
      guaranteedPrizePool
      hasDayTwoStart
      hasSatellite
      isFlightTourn
      internalReference
      isPlayMoney
      isHiLo
      isPwdProtected
      isRestricted
      knockout
      liveEventMask
      maxPayoutSag
      maxPerTable
      maxPlayers
      minPlayers
      nStackInfo {
        forceReloadAllStacksInLevel
        forceReloadAllStacksInMinutes
        initialStacks
        reloadStacksOnlyWhenEmpty
        unitStackChips
      }
      mobileName
      name
      nameSnG
      numReentries
      pokerNgGroup
      pppId
      progressiveKnockout
      rake
      regEndAbs
      regEndAbsInt
      restrictedCountries
      rmPmLobby
      satelliteTarget
      satelliteTarget64
      satelliteTargetName
      satelliteTargetNameMtt
      satelliteTargetReference
      satelliteTargetReferenceLock
      scalePm
      server
      serverObj
      shortText
      sngScriptId
      speedDisplay
      startDelayMinutes
      step
      structure
      targetServer
      targetWhenStart
      timedTournPlayersPercent
      timedTournPayout
      timedTournTime
      timedTournType
      tournBrand
      tournFlags
      tournFlags2
      tournFlagsServInt
      tournGroup
      tournGroupNameStr
      tournGroupRef
      tournMask
      tournMask2
      tournMask3
      tournMask4
      tournSites
      tournMask6
      tournMask5
      tournSitesEx
      tournamentId
      whenStart
      whenStartInt
    }
    userHasTicket
  }
`;
export const TournInviteFragmentDoc = gql`
  fragment TournInvite on TournInvite {
    clubId
    isRestarted
    seatsAvailable
    obsolete1
    obsolete2
    pppEntryId
    pppId
    server
    sngScriptId
    tableTrait
    tournFlags
    tournMsg
    tournToRematchId
    tournamentId
  }
`;
export const ActiveGamesUpdateDocument = gql`
  subscription ActiveGamesUpdate {
    activeGames {
      joined
      tables {
        ...TableData
      }
      zoomTypes {
        ...ZoomDataStruct
      }
      tournaments {
        ...TournDataStruct
      }
      tournInvite {
        ...TournInvite
      }
    }
  }
  ${TableDataFragmentDoc}
  ${ZoomDataStructFragmentDoc}
  ${TournDataStructFragmentDoc}
  ${TournInviteFragmentDoc}
`;

/**
 * __useActiveGamesUpdateSubscription__
 *
 * To run a query within a React component, call `useActiveGamesUpdateSubscription` and pass it any options that fit your needs.
 * When your component renders, `useActiveGamesUpdateSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveGamesUpdateSubscription({
 *   variables: {
 *   },
 * });
 */
export function useActiveGamesUpdateSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    Types.ActiveGamesUpdateSubscription,
    Types.ActiveGamesUpdateSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    Types.ActiveGamesUpdateSubscription,
    Types.ActiveGamesUpdateSubscriptionVariables
  >(ActiveGamesUpdateDocument, options);
}
export type ActiveGamesUpdateSubscriptionHookResult = ReturnType<
  typeof useActiveGamesUpdateSubscription
>;
export type ActiveGamesUpdateSubscriptionResult =
  Apollo.SubscriptionResult<Types.ActiveGamesUpdateSubscription>;
export const ActiveGamesDocument = gql`
  query ActiveGames {
    activeGames {
      tables {
        ...TableData
      }
      joined
      tournaments {
        ...TournDataStruct
      }
      zoomTypes {
        ...ZoomDataStruct
      }
      tournInvite {
        ...TournInvite
      }
    }
  }
  ${TableDataFragmentDoc}
  ${TournDataStructFragmentDoc}
  ${ZoomDataStructFragmentDoc}
  ${TournInviteFragmentDoc}
`;

/**
 * __useActiveGamesQuery__
 *
 * To run a query within a React component, call `useActiveGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveGamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveGamesQuery(
  baseOptions?: Apollo.QueryHookOptions<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>(
    ActiveGamesDocument,
    options
  );
}
export function useActiveGamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>(
    ActiveGamesDocument,
    options
  );
}
export function useActiveGamesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<Types.ActiveGamesQuery, Types.ActiveGamesQueryVariables>(
    ActiveGamesDocument,
    options
  );
}
export type ActiveGamesQueryHookResult = ReturnType<typeof useActiveGamesQuery>;
export type ActiveGamesLazyQueryHookResult = ReturnType<typeof useActiveGamesLazyQuery>;
export type ActiveGamesSuspenseQueryHookResult = ReturnType<typeof useActiveGamesSuspenseQuery>;
export type ActiveGamesQueryResult = Apollo.QueryResult<
  Types.ActiveGamesQuery,
  Types.ActiveGamesQueryVariables
>;
